<template>
  <svg width="18" height="17" viewBox="-4 0 27 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.5 14L1.5 18L5.5 17L17.0858 5.41421C17.8668 4.63316 17.8668 3.36683 17.0858 2.58579L16.9142 2.41421C16.1332 1.63316 14.8668 1.63317 14.0858 2.41421L2.5 14Z" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12.5 4L15.5 7" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.5 18H18.5" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
